import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import sessionStorage from 'redux-persist/lib/storage/session';
import { globalReducer } from './slice/globalSlice';
import { modalReducer } from './slice/modal.store';
import { packageAssignedReducer } from './slice/packageAssigned';
import { changeSimReducer } from './slice/changeSimSlice';
import { connectionReducer } from './slice/connectionSlice';
import { userProfileReducer } from './slice/userProfile';
import { esimManagementReducer } from './slice/esimManagementSlice';
import { registerAndCancelPackageReducer } from './slice/registerAndCancelPackage';
import { forgotPasswordReducer } from './slice/forgotPasswordSlice';

const rootReducer = combineReducers({
  global: globalReducer,
  modal: modalReducer,
  packageAssigned: packageAssignedReducer,
  registerAndCancel: registerAndCancelPackageReducer,
  changeSim: changeSimReducer,
  connection: connectionReducer,
  userProfile: userProfileReducer,
  esimManagement: esimManagementReducer,
  forgotPassword: persistReducer(
    { key: 'forgotPassword', storage: sessionStorage },
    forgotPasswordReducer,
  ),
});
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
